export const Map = 0;
export const Costs = 1;
export const Custom = 2;
export const Trigger = 3;
export const Preprocessing = 4;